import { render, staticRenderFns } from "./basic-select.vue?vue&type=template&id=2ccd2d77"
import script from "./basic-select.vue?vue&type=script&lang=js"
export * from "./basic-select.vue?vue&type=script&lang=js"
import style0 from "./basic-select.vue?vue&type=style&index=0&id=2ccd2d77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports